// v2 – throttled & guarded (nur auf Produktseiten aktiv)
(() => {
  // Doppel-Init vermeiden
  if (window.__spzGpoLiveInit) return;

  // --- Seite prüfen: nur Produktseiten ---
  const isProductPage = (() => {
    const b = document.body;
    const t =
      (b && b.dataset && b.dataset.template) ||
      document.documentElement.getAttribute('data-template') ||
      '';
    return (
      (b && b.classList && b.classList.contains('template-product')) ||
      t.toLowerCase().includes('product') ||
      window.location.pathname.includes('/products/')
    );
  })();

  if (!isProductPage) return; // auf Kategorieseiten etc. nichts tun

  // Hook/Globo vorhanden? (falls nicht, ebenfalls nichts tun)
  const hasHookOrGlobo = !!(
    document.querySelector('.spz-gpo-live') ||
    document.querySelector('.gpo-app, .gpo--app, [data-gpo-root]')
  );
  if (!hasHookOrGlobo) return;

  // Erst jetzt markieren, dass wir laufen
  window.__spzGpoLiveInit = true;

  // -------- Utils --------
  const CUR =
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    document.documentElement.getAttribute('data-shop-currency') ||
    (document.querySelector('meta[property="og:price:currency"]')?.content) ||
    'EUR';

  const LOCALE = document.documentElement.lang || navigator.language || 'de-DE';
  const fmt = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CUR });

  const moneyToNumber = (str) => {
    if (!str) return 0;
    // „12,95“, „€12.95“, „12.95 EUR“ …
    const m = String(str).match(/[-+]?\d{1,3}(\.\d{3})*(,\d+)?|[-+]?\d+(\.\d+)?/);
    if (!m) return 0;
    const raw = m[0].replace(/\./g, '').replace(',', '.');
    const n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  };

  const debounce = (fn, ms = 120) => {
    let t;
    return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
  };

  // Basispreis aus dem Price-Block lesen
  const readBasePriceFromBlock = (priceBlock) => {
    if (!priceBlock) return 0;
    const prefers = priceBlock.querySelectorAll(
      '.price, .price__current, [data-product-id], .price-item, .price__regular, .price__sale'
    );
    for (const el of prefers) {
      const txt = el.textContent?.trim();
      if (txt && /\d/.test(txt)) return moneyToNumber(txt);
    }
    return moneyToNumber(priceBlock.textContent || '');
  };

  // Addon aus Globo lesen (eng gefasst, performant)
  const readAddonFromGlobo = () => {
    const root = document.querySelector('.gpo-app, .gpo--app, [data-gpo-root]');
    if (!root) return 0;

    // 0) "keine" erkannt? -> keine Aufpreise
    const noneChecked =
      !!root.querySelector('input[type="radio"][value*="keine" i]:checked, input[type="checkbox"][value*="keine" i]:checked') ||
      Array.from(root.querySelectorAll('label')).some(l => /keine/i.test(l.textContent || '') && l.querySelector('input:checked'));
    if (noneChecked) return 0;

    // A) typischer Hinweis-Text (nur in geeigneten Knoten suchen)
    const candidates = root.querySelectorAll(
      'p, .gpo-paragraph, .gpo-summary, .gpo-total, [class*="summary"], [class*="total"], [class*="addon"], [class*="price"]'
    );
    for (const el of candidates) {
      const txt = el.textContent?.trim();
      if (!txt) continue;
      if (/zum Preis hinzu/i.test(txt) || /Diese\s+Druckoption\s+fügt/i.test(txt)) {
        const n = moneyToNumber(txt);
        if (n > 0) return n;
      }
    }

    // B) Fallback – data-price aggregieren, aber nur wenn "aktiv"
    let sum = 0;
    const priced = root.querySelectorAll('[data-price], [data-addon-price]');
    priced.forEach((el) => {
      const input = el.matches('input') ? el : el.querySelector('input');
      const isOn =
        input ? input.checked
              : (el.classList.contains('is-active') || el.getAttribute('aria-pressed') === 'true');
      if (isOn) {
        const val = el.getAttribute('data-price') || el.getAttribute('data-addon-price');
        sum += moneyToNumber(val);
      }
    });
    return sum > 0 ? sum : 0;
  };

  // --- UI aktualisieren ---
  const updateUi = () => {
    const hook = document.querySelector('.spz-gpo-live');
    if (!hook) return;

    const priceBlock = hook.closest('product-price') || document.querySelector('product-price');
    const base  = readBasePriceFromBlock(priceBlock);
    // BSS fix
    if(priceBlock.querySelector(".bss-b2b-price-no-vat")) return;
    // end fix
    const addon = readAddonFromGlobo();

    const addonNode = hook.querySelector('[data-spz-gpo-addon]');
    const sumRow    = hook.querySelector('.spz-gpo-live__row--total');
    const sumNode   = hook.querySelector('[data-spz-gpo-sum]');

    // Aufpreis immer setzen (mit +/-)
    if (addonNode) addonNode.textContent = (addon > 0 ? '+' : '') + fmt.format(addon);

    if (addon > 0 && sumRow && sumNode) {
      // sichtbar + neu berechnen
      sumRow.hidden = false;
      sumNode.textContent = fmt.format(base + addon);
    } else {
      // sicherheitshalber Text auf Basispreis setzen und Zeile ausblenden
      if (sumNode) sumNode.textContent = fmt.format(base);
      if (sumRow)  sumRow.hidden = true;
    }
  };

  const safeUpdate = debounce(updateUi, 120);

  const setupObservers = () => {
    // Globo
    const gpoRoot = document.querySelector('.gpo-app, .gpo--app, [data-gpo-root]');
    if (gpoRoot) {
      const mo1 = new MutationObserver(safeUpdate);
      mo1.observe(gpoRoot, { subtree: true, childList: true });
      gpoRoot.addEventListener('change', safeUpdate, true);
      gpoRoot.addEventListener('click', safeUpdate, true);
      gpoRoot.addEventListener('input', safeUpdate, true);
    }

    // Preisblock (Variantenwechsel etc.)
    const priceBlock = document.querySelector('product-price');
    if (priceBlock) {
      const mo2 = new MutationObserver(safeUpdate);
      mo2.observe(priceBlock, { subtree: true, childList: true });
    }

    // Shopify Section Events
    document.addEventListener('shopify:section:load', safeUpdate);
    document.addEventListener('shopify:section:select', safeUpdate);

    // Sicherheitsnetz: auch bei hash-/query-Änderungen aktualisieren
    window.addEventListener('popstate', safeUpdate);
  };

  const init = () => { setupObservers(); safeUpdate(); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();